import React from 'react';
import Header from './Header';
import HeroSection from './HeroSection';
import NewProducts from './NewProducts';
import Categories from './Categories';
import PreferredProducts from './PreferredProducts';
import QualitySection from './QualitySection';
import BlogSection from './BlogSection';
import GlobalPresenceMap from './GlobalPresenceMap';
import Footer from './Footer';
import SEOHead from './SEOHead';
import { useLanguage } from '../contexts/LanguageContext';

const HomePage = () => {
  const { currentLanguage } = useLanguage();
  return (
    <div className="min-h-screen bg-capsule-bg">
      <SEOHead page="home" />
      <Header />
      <HeroSection />
      <div className="bg-white">
        <NewProducts />
      </div>
      <div className="bg-capsule-bg-light">
        <Categories />
      </div>
      <div className="bg-white">
        <QualitySection />
      </div>
      <div className="bg-capsule-bg-light">
        <PreferredProducts />
      </div>
      <GlobalPresenceMap currentLanguage={currentLanguage} />
      <div className="bg-white">
        <BlogSection />
      </div>
      <Footer />
    </div>
  );
};

export default HomePage;
